import {getRelativeYearDate} from "./../../../helper/custom-function";
// ─── Master Table (List View) ─────────────────────────────────────────────────
const masterTableFields = [
    {
        title: 'Auditor Id',
        is_searchable: false,
        class_name: 'w-110p',
        field: { type: 'number', name: 'id' },
        fetch_key: 'id'
    },
    {
        title: 'Name',
        is_searchable: true,
        field: { type: 'text', name: 'name' },
        fetch_key: 'full_name'
    },
    {
        title: 'Gender',
        is_searchable: false,
        class_name: 'w-110p',
        field: { type: 'text', name: 'gender' },
        fetch_key: 'gender'
    },
    {
        title: 'Email',
        is_searchable: false,
        field: { type: 'text', name: 'email' },
        fetch_key: 'user_email.email'
    },
    {
        title: 'Mobile',
        is_searchable: false,
        field: { type: 'text', name: 'mobile_number' },
        fetch_key: 'user_mobile.full_mobile'
    },
    {
        title: 'College',
        is_searchable: true,
        field: { type: 'text', name: 'college' },
        fetch_key: 'college'
    },
    {
        title: 'Year in College',
        is_searchable: false,
        class_name: 'w-125p',
        field: { type: 'text', name: 'grade' },
        fetch_key: 'grade'
    },
    {
        title: 'Subject',
        is_searchable: false,
        field: { type: 'text', name: 'subject_specialisation' },
        fetch_key: 'subject_specialisation'
    },
    {
        title: 'Internship Start',
        is_searchable: false,
        class_name: 'w-140p',
        field: { type: 'text', name: 'internship_start_date' },
        fetch_key: 'internship_start_date'
    },
    {
        title: 'DOB',
        is_searchable: false,
        field: { type: 'text', name: 'dob' },
        fetch_key: 'dob'
    },
    {
        title: 'Status',
        is_searchable: true,
        class_name: 'w-110p',
        field: { type: 'select', name: 'active_status_id' },
        option_label: 'status',
        option_val: 'id',
        fetch_key: 'active_status_id'
    }
];

// ─── New Entry Form ────────────────────────────────────────────────────────────
const fieldNewAuditor = [
    // Row 1: name
    { colMd: '6', label: 'First Name',                required: true, type: 'text',         name: 'first_name' },
    { colMd: '6', label: 'Last Name',                 required: true, type: 'text',         name: 'last_name' },

    // Row 2: gender + dob
    { colMd: '6', label: 'Gender',                    required: true, type: 'select',       name: 'gender_id',   placeholderData: ['Select Gender'] },
    { colMd: '6', label: 'Date of Birth',             required: true, type: 'date',         name: 'dob', min: getRelativeYearDate(-100), max: getRelativeYearDate(-13)},

    // Row 3: email + mobile
    { colMd: '6', label: 'Email',                     required: true, type: 'email',        name: 'email' },
    { colMd: '2', label: 'Dialing Code',              required: true, type: 'select',       name: 'mobile_code_id'},
    { colMd: '4', label: 'Mobile Number',             required: true, type: 'text',         name: 'mobile_number'},

    // Row 4: college + year
    { colMd: '6', label: 'College',                    required: true, type: 'text',         name: 'college' },
    { colMd: '6', label: 'Year in College',            required: true, type: 'select',       name: 'grade_id', placeholderData: ['Select Year'] },

    // Row 5: subject + internship start
    { colMd: '6', label: 'Subject of Specialisation',  required: true, type: 'text',         name: 'subject_specialisation' },
    { colMd: '6', label: 'Internship Start Date',      required: true, type: 'date',         name: 'internship_start_date' },

    // Row 6: time slots (multi-select, full width)
    { colMd: '12', label: 'Availability for Sessions', required: true, type: 'multi-select', name: 'slot_availability_ids',
      placeholderData: ['Select time slots']},

    // Row 8: optional fields
    { colMd: "6", label: "Password",                   required: true,  type: "text",         name: "password", tagline: "Min 8 Characters, Max 15 Characters"},
    { colMd: '6', label: 'UPI ID',                     required: false, type: 'text',         name: 'upi_id'},
    { colMd: '12', label: 'Comments / Remarks',        required: false, type: 'textarea',     name: 'remarks', max: 1000},
];

// ─── Initial form values (new) ────────────────────────────────────────────────
const fieldValuesAuditor = {
    first_name:             '',
    last_name:              '',
    gender_id:              '',
    dob:                    '',
    email:                  '',
    password:               '',
    mobile_code_id:         {id: 101, phone_code: '91'},
    mobile_number:          '',
    college:                '',
    grade_id:               '',
    subject_specialisation: '',
    internship_start_date:  '',
    slot_availability_ids:   '',
    upi_id:                 '',
    remarks:                '',
};

// ─── Validation: New ──────────────────────────────────────────────────────────
// Rules use the ValidationHelper format: 'rule|rule:param||Display Name'
const fieldValidationAuditor = {
    first_name:             'required|max:50||First Name',
    last_name:              'required|max:50||Last Name',
    gender_id:              'required||Gender',
    dob:                    'required||Date of Birth',
    password:               'required|min:8|max:15',
    email:                  'required|email|max:150||Email',
    mobile_code_id:         'required||Dialing Code',
    mobile_number:          'required|min:10|max:10||Mobile Number',
    college:                'required|max:100||College',
    grade_id:               'required||Year in College',
    subject_specialisation: 'required|max:150||Subject of Specialisation',
    internship_start_date:  'required||Internship Start Date',
    slot_availability_ids:   'required||Availability for Sessions',
    upi_id:                 'optional|max:250||UPI ID',
    remarks:                'optional|max:1000||Remarks',
};

// ─── Validation: Edit ─────────────────────────────────────────────────────────
// All optional in edit; only changed fields are sent to the API.
const fieldValidEditAuditor = {
    first_name:             'required|max:50||First Name',
    last_name:              'required|max:50||Last Name',
    gender_id:              'required||Gender',
    dob:                    'required||Date of Birth',
    password:               'optional|min:8|max:15',
    // mobile_code_id:         'required||Dialing Code',
    // mobile_number:          'required|min:6|max:15||Mobile Number',
    college:                'required|max:100||College',
    grade_id:               'required||Year in College',
    subject_specialisation: 'required|max:150||Subject of Specialisation',
    internship_start_date:  'required||Internship Start Date',
    slot_availability_ids:  'required||Availability for Sessions',
    upi_id:                 'optional|max:250||UPI ID',
    remarks:                'optional|max:1000||Remarks',
};

// ─── Edit Form Fields ─────────────────────────────────────────────────────────
// Email is excluded from edit (cannot change after creation, same as stakeholder pattern).
const fieldEditAuditor = [
    { colMd: '6',  label: 'First Name',               required: true,  type: 'text',         name: 'first_name' },
    { colMd: '6',  label: 'Last Name',                required: true,  type: 'text',         name: 'last_name' },
    { colMd: '6',  label: 'Gender',                   required: true, type: 'select',       name: 'gender_id',         placeholderData: ['Select Gender'] },
    { colMd: '6',  label: 'Date of Birth',            required: true, type: 'date',         name: 'dob', min: getRelativeYearDate(-100), max: getRelativeYearDate(-13) },
    // { colMd: '6',  label: 'Mobile Number',            required: false, type: 'text',         name: 'mobile_number' },
    { colMd: '6',  label: 'College',                  required: true, type: 'text',         name: 'college' },
    { colMd: '6',  label: 'Year in College',          required: true, type: 'select',       name: 'grade_id',   placeholderData: ['Select Year'] },
    { colMd: '6',  label: 'Subject of Specialisation', required: true, type: 'text',        name: 'subject_specialisation' },
    { colMd: '6',  label: 'Internship Start Date',    required: true, type: 'date',         name: 'internship_start_date' },
    { colMd: '12', label: 'Availability for Sessions', required: true, type: 'multi-select', name: 'slot_availability_ids',        placeholderData: ['Select time slots'] },
    { colMd: '6',  label: 'UPI ID',                   required: false, type: 'text',         name: 'upi_id' },
    { colMd: "6",  label: "Password",                 required: false, type: "text",         name: "password", tagline: "Min 8 Characters, Max 15 Characters"},
    { colMd: '12', label: 'Comments / Remarks',       required: false, type: 'textarea',     name: 'remarks' },
];

// ─── View (Detail Modal) Fields ───────────────────────────────────────────────
const fieldAuditorView = [
    { label: 'First Name',               type: 'string', value_key: 'first_name' },
    { label: 'Last Name',                type: 'string', value_key: 'last_name' },
    { label: 'Gender',                   type: 'string', value_key: 'gender' },
    { label: 'Date of Birth',            type: 'string', value_key: 'dob' },
    { label: 'Email',                    type: 'object', value_key: 'user_email.email' },
    { label: 'Mobile Number',            type: 'object', value_key: 'user_mobile.full_mobile' },
    { label: 'College',                  type: 'string', value_key: 'college' },
    { label: 'Year in College',          type: 'string', value_key: 'grade_id' },
    { label: 'Subject of Specialisation', type: 'string',value_key: 'subject_specialisation' },
    { label: 'Internship Start Date',    type: 'string', value_key: 'internship_start_date' },    
    { label: "Session Availability",     type: "array",  value_key: "availability_slots", array_key: "slot_name"},
    { label: 'UPI ID',                   type: 'string', value_key: 'upi_id' },
    { label: 'Remarks',                  type: 'string', value_key: 'remarks' },
];

// ─── Filter ───────────────────────────────────────────────────────────────────
const filterTableData = [
    {colMd: "3", label: "Name",                      type: "text",         name: "name"},
    {colMd: "3", label: "Email",                     type: "text",         name: "email"},
    {colMd: "3", label: "Availability Slot",         type: "multi-select", name: "slot_availability_ids"},
    {colMd: "3", label: "Year in College",           type: "multi-select", name: "grade_id"},
    {colMd: "3", label: "Status",                    type: "select",       name: "active_status_id"},
    {colMd: "9", label: "Subject of Specialisation", type: "text",         name: "subject_specialisation"},
];

// ─── Export ───────────────────────────────────────────────────────────────────
const data = {
    masterTableFields,
    fieldNewAuditor,
    fieldValuesAuditor,
    fieldValidationAuditor,
    fieldValidEditAuditor,
    fieldEditAuditor,
    fieldAuditorView,
    filterTableData
};

export default data;
